import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import each from 'lodash/each';

export default function PropertyTab({
  className = '',
  javascriptInitializer,
  tabPath
}) {
  const [tabHTML, setTabHTML] = useState(null);

  useEffect(() => {
    const headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'text/html; charset=utf-8'
    };

    const abortController = new AbortController();

    axios
      .get(tabPath, { headers, signal: abortController.signal })
      .then(response => setTabHTML({ __html: response.data }))
      .catch((error) => {
        // eslint-disable-next-line no-console
        if (!axios.isCancel(error)) console.log(error);
      });

    return () => abortController.abort();
  }, []);

  const initializeJavascript = useCallback((node) => {
    if (!node) return;

    // In the case that this tab has its own embedded script tag, we need to reinsert it manually
    // to get it to run since script tags won't be run when setting HTML with reacts dangerouslySetInnerHTML
    const scriptNodes = node.querySelectorAll('script');
    each(scriptNodes, (scriptNode) => {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.type = scriptNode.type;
      s.innerHTML = scriptNode.innerHTML;
      node.appendChild(s);
    });


    if (javascriptInitializer) javascriptInitializer($(node), tabPath);
  }, []);

  if (!tabPath) {
    return (
      <div>Tab not supported</div>
    );
  }

  if (tabHTML) {
    const childElement =
      <div
        className={`${className}`}
        dangerouslySetInnerHTML={tabHTML}
        ref={initializeJavascript}
      />;

    return childElement;
  }

  return (
    <div className="text-center my-5">
      <FontAwesomeIcon icon={faSpinner} size="2x" spin/>
    </div>
  );
}

PropertyTab.propTypes = {
  className: PropTypes.string,
  javascriptInitializer: PropTypes.func,
  panelBodyClassName: PropTypes.string,
  tabPath: PropTypes.string
};
